export const ProfileIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5396 3.89307C8.94321 3.89307 6.81887 6.06031 6.81887 8.73066C6.81887 11.401 8.94321 13.5683 11.5396 13.5683C14.136 13.5683 16.2604 11.401 16.2604 8.73066C16.2604 6.06031 14.136 3.89307 11.5396 3.89307ZM6.60644 13.5683C4.10444 13.665 2.09811 15.3485 2.09811 17.4383V19.3734H20.9811V17.4383C20.9811 15.3485 18.9984 13.665 16.4728 13.5683C15.1982 14.7486 13.4515 15.5033 11.5396 15.5033C9.62772 15.5033 7.88104 14.7486 6.60644 13.5683Z"
      fill="#8090A9"
    />
  </svg>
);
